import React, { FC } from 'react';

import { Button, Icon } from '../../../../shared/ui';
import { IconMap } from '../../../../shared/sprite';
import { useCollaboration } from '../../../../entities/collaboration';

type Props = {
  isUploading?: boolean;
  clickHandler(): void;
  openColorTab: () => void;
  progress?: number;
  closeOptions: () => void;
};

export const PageCoverImageTab: FC<Props> = ({
  isUploading,
  clickHandler,
  openColorTab,
  progress,
  closeOptions,
}) => {
  const {
    coverImageUrl,
    originalBrandCoverImageUrl,
    updateCoverImageUrl,
    updateCoverColor,
  } = useCollaboration();

  const handleRestoreCompanyImage = () => {
    updateCoverImageUrl(originalBrandCoverImageUrl);
    updateCoverColor(null);
    closeOptions();
  };

  return (
    <div>
      <div className="flex items-center gap-4">
        <Button
          color="primary"
          variant="icon-text"
          onClick={clickHandler}
          loading={isUploading}
          size="md"
          fullWidth
        >
          <Icon glyph={IconMap.Paperclip02} width={16} className="mr-1.5" />
          {coverImageUrl ? 'Select new cover' : 'Select cover'}
        </Button>
        {originalBrandCoverImageUrl && (
          <>
            <span className="text-sm text-gray-600">or</span>
            <Button
              color="secondary"
              className="font-semibold"
              variant="text"
              onClick={handleRestoreCompanyImage}
              size="md"
              fullWidth
            >
              Restore company cover
            </Button>
          </>
        )}
      </div>

      {Boolean(progress) && isUploading && (
        <p className="mt-2 text-sm font-normal text-gray-500">{progress}%</p>
      )}
      <div className="pb-5 mt-3 mb-5 border-b border-gray-400 border-dotted">
        <span className="block text-sm font-normal text-gray-600">
          PNG or JPG (max. 10 MB)
        </span>
        <span className="block text-sm font-normal text-gray-600">
          Recommended size is 2048px by 500px
        </span>
      </div>

      <div>
        <span className="text-sm font-normal text-gray-500">
          Don’t have a good image?
        </span>
        <button
          className="inline ml-1 text-sm font-semibold text-primary-700"
          onClick={openColorTab}
        >
          Apply a solid color.
        </button>
      </div>
    </div>
  );
};
